/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Paper, Typography, CircularProgress } from '@material-ui/core'

import Actions from '../../../fluid/Actions/ActionFactory'
import signals from '../DataGenerator/Signals';

import RangeSelector from '../components/RangeSelector/RangeSelector'
import ChartComponent from '../components/Charts/ChartComponent'

import ICStatsConfig from './ICStatsConfig'
import KeyMetric from '../components/Charts/KeyMetric';

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({})

class ICDashboard extends Component {
    state = {
        loading : false,
        drl_url : null,
        drl_url_error : false,
        date_filter : null,
        entities : null,
        entities_error : false,
        filter : null
    }

    componentWillMount () {
        this.setState({
            ...this.state,
            loading : true
        }, () => {
            Actions('http_request', {
                url : "/sainapse/data_rendering_service",
                method : "get",
                data : {}
            }).then(res => {
                let drl_url = res.data.result[0].url
                Actions ('http_request', {
                    url : drl_url + '/analytics/cube/signal',
                    method : 'get'
                })
                Actions('http_request', {
                    url: "/sainapse/information_channel",
                    method: "get",
                    data : {}
                }).then (res => {
                    this.setState({
                        ...this.state, 
                        drl_url : drl_url, 
                        entities : res.data.result,
                        drl_url_error : false,
                        entities_error : false,
                        loading : false
                    })
                }).catch(err => {
                    this.setState({
                        ...this.state, 
                        drl_url : drl_url, 
                        entities : null,
                        drl_url_error : false,
                        entities_error : true,
                        loading : false
                    })
                })
            }).catch(err => {
                this.setState({
                    ...this.state, 
                    drl_url : null, 
                    entities : null,
                    drl_url_error : true,
                    entities_error : true,
                    loading : false
                })
            })
        })
    }

    handleFilterChange = (filter) => {
        this.setState({
            ...this.state,
            filter : {...filter}
        })
    }

    renderCharts = () => {
        if (this.state.entities) {
            let charts = ICStatsConfig.map(chart => {
                return (
                    <div style = {{width : chart.width, height : '470px', padding: '10px'}}>
                        <ChartComponent key = {chart.name} drl_url = {this.state.drl_url} filter = {this.state.filter} chart_config = {chart} height = {450} signal_type = {chart.signal_type} entities = {this.state.entities}/>
                    </div>
                )
            })

            return charts
        }
    }

    renderKeyMetrics = () => {
        if (this.state.entities) {
            return (
                <div style = {{width : '100%', display : 'flex', flexDirection : 'row', flexWrap : 'wrap', marginTop : '5px', justifyContent : 'space-around'}}>
                    <div style = {{width : '30%'}}>
                        <KeyMetric value = {this.state.entities.length} label = "Total Information Channels"/>
                    </div>
                    <div style = {{width : '30%'}}>
                        <KeyMetric value = {null} label = "Total Messages Processed" drl_url = {this.state.drl_url} filter = {this.state.filter} signal_type = "NUM_OF_MSGS" entities = {this.state.entities}/>
                    </div>
                    <div style = {{width : '30%'}}>
                        <KeyMetric value = {null} label = "Total Queries Processed" drl_url = {this.state.drl_url} filter = {this.state.filter} signal_type = "NUM_QUERIES" entities = {this.state.entities}/>
                    </div>
                </div>
            )
        }
    }

    renderAnalytics = () => {
        if (this.state.loading === true) {
            return (
                <div style = {{width : '100%', height : 'calc(100vh - 100px)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems: 'center'}}>
                    <CircularProgress color = 'primary'/>
                </div>
            )
        } else {
            return (
                <div style = {{width : '100%', maxHeight : 'calc(100vh - 100px)', overflow : 'auto'}}>
                    <div style = {{width : '100%', padding : '10px'}}>
                        <div style = {{width : '100%', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                            <Typography variant = 'subtitle2'>Key Metrics</Typography>
                        </div>
                        {this.renderKeyMetrics()}
                    </div>
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', flexWrap : 'wrap', borderTop : '1px solid rgba(0,0,0,0.12)'}}>
                        {this.renderCharts()}
                    </div>
                </div>
            )
        }
    }

    render() {
        return (
            <ThemeProvider theme ={blue_theme}>
                <Paper square elevation = {2} style = {{width : '100%', height: '50px', display : 'flex', flexDirection :'row', alignItems : 'center', padding : '5px', marginBottom : '3px'}}>
                    <Typography style = {{fontWeight : 600, flexGrow : 1}} variant = 'h6'>Information Channel Statistics</Typography>
                    <RangeSelector onClose = {(filter) => this.handleFilterChange(filter)}/>
                </Paper>
                {this.renderAnalytics()}
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(ICDashboard);